var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2623 73.6372C66.7377 73.6372 82.5257 57.8492 82.5257 38.3739C82.5257 18.8985 66.7377 3.11053 47.2623 3.11053C27.787 3.11053 11.999 18.8985 11.999 38.3739C11.999 57.8492 27.787 73.6372 47.2623 73.6372Z",
    fill: "url(#paint0_linear_1714_6216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2623 73.6372C66.7377 73.6372 82.5257 57.8492 82.5257 38.3739C82.5257 18.8985 66.7377 3.11053 47.2623 3.11053C27.787 3.11053 11.999 18.8985 11.999 38.3739C11.999 57.8492 27.787 73.6372 47.2623 73.6372Z",
    fill: "url(#paint1_radial_1714_6216)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3447 72.5062C66.2403 72.5062 81.5582 57.1883 81.5582 38.2927C81.5582 19.3967 66.2403 4.0788 47.3447 4.0788C28.449 4.0788 13.1309 19.3967 13.1309 38.2927C13.1309 57.1883 28.449 72.5062 47.3447 72.5062Z",
    fill: "#DDCEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3447 72.5062C66.2403 72.5062 81.5582 57.1883 81.5582 38.2927C81.5582 19.3967 66.2403 4.0788 47.3447 4.0788C28.449 4.0788 13.1309 19.3967 13.1309 38.2927C13.1309 57.1883 28.449 72.5062 47.3447 72.5062Z",
    fill: "url(#paint2_radial_1714_6216)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2285 4.17425C54.4961 2.77475 67.5439 7.20683 73.9355 18.0452C65.6707 10.106 56.8906 5.21434 44.2285 4.17425Z",
    fill: "url(#paint3_radial_1714_6216)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2628 62.6366C60.663 62.6366 71.5259 51.774 71.5259 38.3738C71.5259 24.9739 60.663 14.1109 47.2628 14.1109C33.8629 14.1109 23 24.9739 23 38.3738C23 51.774 33.8629 62.6366 47.2628 62.6366Z",
    fill: "#D8CBF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2628 62.6366C60.663 62.6366 71.5259 51.774 71.5259 38.3738C71.5259 24.9739 60.663 14.1109 47.2628 14.1109C33.8629 14.1109 23 24.9739 23 38.3738C23 51.774 33.8629 62.6366 47.2628 62.6366Z",
    fill: "url(#paint4_radial_1714_6216)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2628 62.6366C60.663 62.6366 71.5259 51.774 71.5259 38.3738C71.5259 24.9739 60.663 14.1109 47.2628 14.1109C33.8629 14.1109 23 24.9739 23 38.3738C23 51.774 33.8629 62.6366 47.2628 62.6366Z",
    fill: "url(#paint5_radial_1714_6216)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2628 62.6366C60.663 62.6366 71.5259 51.774 71.5259 38.3738C71.5259 24.9739 60.663 14.1109 47.2628 14.1109C33.8629 14.1109 23 24.9739 23 38.3738C23 51.774 33.8629 62.6366 47.2628 62.6366Z",
    fill: "url(#paint6_radial_1714_6216)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3975 17.6002V46.5581L79.8134 43.925C75.3771 42.1564 72.4551 37.4792 72.4551 32.2124V17.6002H86.3975Z",
    fill: "#B9A9D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3289 0C86.9425 0 89.8735 2.86906 89.8735 6.40633V42.4011H81.4387C76.8469 40.4324 73.9739 35.9841 73.9739 31.01V9.19695C73.9338 4.12683 78.1095 0 83.3289 0Z",
    fill: "url(#paint7_linear_1714_6216)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3289 0C86.9425 0 89.8735 2.86906 89.8735 6.40633V42.4011H81.4387C76.8469 40.4324 73.9739 35.9841 73.9739 31.01V9.19695C73.9338 4.12683 78.1095 0 83.3289 0Z",
    fill: "url(#paint8_radial_1714_6216)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3289 0C86.9425 0 89.8735 2.86906 89.8735 6.40633V42.4011H81.4387C76.8469 40.4324 73.9739 35.9841 73.9739 31.01V9.19695C73.9338 4.12683 78.1095 0 83.3289 0Z",
    fill: "url(#paint9_radial_1714_6216)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3289 0C86.9425 0 89.8735 2.86906 89.8735 6.40633V42.4011H81.4387C76.8469 40.4324 73.9739 35.9841 73.9739 31.01V9.19695C73.9338 4.12683 78.1095 0 83.3289 0Z",
    fill: "url(#paint10_radial_1714_6216)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8688 3.11053C85.3019 3.11053 87.2751 5.0422 87.2751 7.42379V39.5557C82.8688 39.5557 76.5705 36.1839 76.5705 27.8068V9.30267C76.5433 5.88904 79.3546 3.11053 82.8688 3.11053Z",
    fill: "url(#paint11_linear_1714_6216)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4014 42.4011V48.5756V76.3027C81.4014 78.348 83.0879 79.9997 85.1756 79.9997H86.0991C88.1871 79.9997 89.8733 78.348 89.8733 76.3027V48.5756V42.4011H81.4014Z",
    fill: "url(#paint12_linear_1714_6216)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4014 42.4011V48.5756V76.3027C81.4014 78.348 83.0879 79.9997 85.1756 79.9997H86.0991C88.1871 79.9997 89.8733 78.348 89.8733 76.3027V48.5756V42.4011H81.4014Z",
    fill: "url(#paint13_radial_1714_6216)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4014 42.4011V48.5756V76.3027C81.4014 78.348 83.0879 79.9997 85.1756 79.9997H86.0991C88.1871 79.9997 89.8733 78.348 89.8733 76.3027V48.5756V42.4011H81.4014Z",
    fill: "url(#paint14_linear_1714_6216)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2524 0.00080111C17.7445 0.00080111 16.5541 1.0568 16.5541 2.31717V12.9513C16.5541 13.6326 15.9191 14.1435 15.1652 14.1435C14.3716 14.1435 13.7764 13.5985 13.7764 12.9513V2.41936C13.7764 1.15899 12.6256 0.0348852 11.1574 0.00080111C9.60984 -0.0332509 8.34001 1.02271 8.34001 2.31717V12.9513C8.34001 13.6326 7.70514 14.1435 6.95119 14.1435C6.15757 14.1435 5.5623 13.5985 5.5623 12.9513V2.41936C5.5623 1.15899 4.41152 0.0348852 2.94331 0.00080111C1.39574 -0.0332509 0.125977 1.02271 0.125977 2.31717V12.6727V14.4782V21.0073C0.125977 27.5968 6.91146 29.3825 6.91146 34.0417V75.7416C6.91146 78.0056 8.81827 80 11.0979 80C13.3774 80 15.2842 78.0056 15.2842 75.7416C15.2842 75.7416 15.2842 38.8667 15.2842 34.0417C15.2842 29.217 22.0698 27.6472 22.0698 21.0073V14.4782V12.6727V2.31717C21.9904 1.0568 20.7603 0.00080111 19.2524 0.00080111Z",
    fill: "url(#paint15_linear_1714_6216)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2524 0.00080111C17.7445 0.00080111 16.5541 1.0568 16.5541 2.31717V12.9513C16.5541 13.6326 15.9191 14.1435 15.1652 14.1435C14.3716 14.1435 13.7764 13.5985 13.7764 12.9513V2.41936C13.7764 1.15899 12.6256 0.0348852 11.1574 0.00080111C9.60984 -0.0332509 8.34001 1.02271 8.34001 2.31717V12.9513C8.34001 13.6326 7.70514 14.1435 6.95119 14.1435C6.15757 14.1435 5.5623 13.5985 5.5623 12.9513V2.41936C5.5623 1.15899 4.41152 0.0348852 2.94331 0.00080111C1.39574 -0.0332509 0.125977 1.02271 0.125977 2.31717V12.6727V14.4782V21.0073C0.125977 27.5968 6.91146 29.3825 6.91146 34.0417V75.7416C6.91146 78.0056 8.81827 80 11.0979 80C13.3774 80 15.2842 78.0056 15.2842 75.7416C15.2842 75.7416 15.2842 38.8667 15.2842 34.0417C15.2842 29.217 22.0698 27.6472 22.0698 21.0073V14.4782V12.6727V2.31717C21.9904 1.0568 20.7603 0.00080111 19.2524 0.00080111Z",
    fill: "url(#paint16_radial_1714_6216)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2524 0.00080111C17.7445 0.00080111 16.5541 1.0568 16.5541 2.31717V12.9513C16.5541 13.6326 15.9191 14.1435 15.1652 14.1435C14.3716 14.1435 13.7764 13.5985 13.7764 12.9513V2.41936C13.7764 1.15899 12.6256 0.0348852 11.1574 0.00080111C9.60984 -0.0332509 8.34001 1.02271 8.34001 2.31717V12.9513C8.34001 13.6326 7.70514 14.1435 6.95119 14.1435C6.15757 14.1435 5.5623 13.5985 5.5623 12.9513V2.41936C5.5623 1.15899 4.41152 0.0348852 2.94331 0.00080111C1.39574 -0.0332509 0.125977 1.02271 0.125977 2.31717V12.6727V14.4782V21.0073C0.125977 27.5968 6.91146 29.3825 6.91146 34.0417V75.7416C6.91146 78.0056 8.81827 80 11.0979 80C13.3774 80 15.2842 78.0056 15.2842 75.7416C15.2842 75.7416 15.2842 38.8667 15.2842 34.0417C15.2842 29.217 22.0698 27.6472 22.0698 21.0073V14.4782V12.6727V2.31717C21.9904 1.0568 20.7603 0.00080111 19.2524 0.00080111Z",
    fill: "url(#paint17_radial_1714_6216)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2524 0.00080111C17.7445 0.00080111 16.5541 1.0568 16.5541 2.31717V12.9513C16.5541 13.6326 15.9191 14.1435 15.1652 14.1435C14.3716 14.1435 13.7764 13.5985 13.7764 12.9513V2.41936C13.7764 1.15899 12.6256 0.0348852 11.1574 0.00080111C9.60984 -0.0332509 8.34001 1.02271 8.34001 2.31717V12.9513C8.34001 13.6326 7.70514 14.1435 6.95119 14.1435C6.15757 14.1435 5.5623 13.5985 5.5623 12.9513V2.41936C5.5623 1.15899 4.41152 0.0348852 2.94331 0.00080111C1.39574 -0.0332509 0.125977 1.02271 0.125977 2.31717V12.6727V14.4782V21.0073C0.125977 27.5968 6.91146 29.3825 6.91146 34.0417V75.7416C6.91146 78.0056 8.81827 80 11.0979 80C13.3774 80 15.2842 78.0056 15.2842 75.7416C15.2842 75.7416 15.2842 38.8667 15.2842 34.0417C15.2842 29.217 22.0698 27.6472 22.0698 21.0073V14.4782V12.6727V2.31717C21.9904 1.0568 20.7603 0.00080111 19.2524 0.00080111Z",
    fill: "url(#paint18_radial_1714_6216)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2524 0.00080111C17.7445 0.00080111 16.5541 1.0568 16.5541 2.31717V12.9513C16.5541 13.6326 15.9191 14.1435 15.1652 14.1435C14.3716 14.1435 13.7764 13.5985 13.7764 12.9513V2.41936C13.7764 1.15899 12.6256 0.0348852 11.1574 0.00080111C9.60984 -0.0332509 8.34001 1.02271 8.34001 2.31717V12.9513C8.34001 13.6326 7.70514 14.1435 6.95119 14.1435C6.15757 14.1435 5.5623 13.5985 5.5623 12.9513V2.41936C5.5623 1.15899 4.41152 0.0348852 2.94331 0.00080111C1.39574 -0.0332509 0.125977 1.02271 0.125977 2.31717V12.6727V14.4782V21.0073C0.125977 27.5968 6.91146 29.3825 6.91146 34.0417V75.7416C6.91146 78.0056 8.81827 80 11.0979 80C13.3774 80 15.2842 78.0056 15.2842 75.7416C15.2842 75.7416 15.2842 38.8667 15.2842 34.0417C15.2842 29.217 22.0698 27.6472 22.0698 21.0073V14.4782V12.6727V2.31717C21.9904 1.0568 20.7603 0.00080111 19.2524 0.00080111Z",
    fill: "url(#paint19_radial_1714_6216)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2394 1.65491C17.9931 1.65491 17.8115 2.81303 17.8115 4.0734V12.6727C17.8115 14.7196 16.2584 15.2207 15.2815 15.2207C14.3045 15.2207 12.551 14.6695 12.551 12.6727V4.0734C12.551 2.81303 12.3757 1.65497 11.3236 1.65497C10.2715 1.65497 10.021 2.77888 10.021 4.07334V12.6727C10.021 14.0653 8.5931 15.2207 6.96486 15.2207C5.76246 15.2207 4.13422 14.416 4.13422 12.6727V4.0734C4.13422 2.81303 3.90874 1.65488 2.85666 1.65488C1.80461 1.65488 1.5791 2.77898 1.5791 4.0734V12.6727V14.4782V21.0073C1.5791 27.5968 8.3927 29.3825 8.3927 34.0417V75.5912C8.3927 77.8556 9.11386 79.1234 10.9979 79.1234C12.8819 79.1234 13.9538 78.0056 13.9538 75.7416C13.9538 75.7416 13.9538 38.8667 13.9538 34.0417C13.9538 29.217 20.8175 27.6472 20.8175 21.0073V14.4782V12.6727L20.567 4.07334C20.5014 2.81296 20.4856 1.65491 19.2394 1.65491Z",
    fill: "url(#paint20_linear_1714_6216)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2394 1.65491C17.9931 1.65491 17.8115 2.81303 17.8115 4.0734V12.6727C17.8115 14.7196 16.2584 15.2207 15.2815 15.2207C14.3045 15.2207 12.551 14.6695 12.551 12.6727V4.0734C12.551 2.81303 12.3757 1.65497 11.3236 1.65497C10.2715 1.65497 10.021 2.77888 10.021 4.07334V12.6727C10.021 14.0653 8.5931 15.2207 6.96486 15.2207C5.76246 15.2207 4.13422 14.416 4.13422 12.6727V4.0734C4.13422 2.81303 3.90874 1.65488 2.85666 1.65488C1.80461 1.65488 1.5791 2.77898 1.5791 4.0734V12.6727V14.4782V21.0073C1.5791 27.5968 8.3927 29.3825 8.3927 34.0417V75.5912C8.3927 77.8556 9.11386 79.1234 10.9979 79.1234C12.8819 79.1234 13.9538 78.0056 13.9538 75.7416C13.9538 75.7416 13.9538 38.8667 13.9538 34.0417C13.9538 29.217 20.8175 27.6472 20.8175 21.0073V14.4782V12.6727L20.567 4.07334C20.5014 2.81296 20.4856 1.65491 19.2394 1.65491Z",
    fill: "url(#paint21_radial_1714_6216)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4531 33.8329V75.6162",
    stroke: "#C3BDCF",
    strokeWidth: 1.34371,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42419 2.85847C4.42419 2.50433 4.13706 2.21719 3.78288 2.21719C3.42873 2.21719 3.1416 2.50433 3.1416 2.85847H4.42419ZM6.61356 16.3379H7.25484V15.0553H6.61356V16.3379ZM3.1416 2.85847V11.8389H4.42419V2.85847H3.1416ZM3.1416 11.8389C3.1416 12.3886 3.27977 13.4549 3.74934 14.4081C4.2269 15.3776 5.11392 16.3379 6.61356 16.3379V15.0553C5.78355 15.0553 5.25523 14.5627 4.89986 13.8414C4.53651 13.1037 4.42419 12.2411 4.42419 11.8389H3.1416Z",
    fill: "url(#paint22_linear_1714_6216)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.64 2.8585C12.64 2.50436 12.3529 2.21722 11.9987 2.21722C11.6446 2.21722 11.3574 2.50436 11.3574 2.8585H12.64ZM14.8294 16.3379H15.4707V15.0554H14.8294V16.3379ZM11.3574 2.8585V11.839H12.64V2.8585H11.3574ZM11.3574 11.839C11.3574 12.3886 11.4956 13.4549 11.9652 14.4081C12.4427 15.3776 13.3297 16.3379 14.8294 16.3379V15.0554C13.9994 15.0554 13.471 14.5628 13.1157 13.8414C12.7523 13.1038 12.64 12.2412 12.64 11.839H11.3574Z",
    fill: "url(#paint23_linear_1714_6216)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4665 2.67059V20.7066C20.4665 23.4622 17.21 27.5202 15.707 28.923",
    stroke: "#C3BDCF",
    strokeWidth: 1.07497,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53368 3.11048C3.99023 3.11048 4.36033 2.74038 4.36033 2.28383C4.36033 1.82729 3.99023 1.45718 3.53368 1.45718C3.07713 1.45718 2.70703 1.82729 2.70703 2.28383C2.70703 2.74038 3.07713 3.11048 3.53368 3.11048Z",
    fill: "#E0DCE8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9243 3.11051C12.3809 3.11051 12.751 2.74041 12.751 2.28386C12.751 1.82732 12.3809 1.45721 11.9243 1.45721C11.4678 1.45721 11.0977 1.82732 11.0977 2.28386C11.0977 2.74041 11.4678 3.11051 11.9243 3.11051Z",
    fill: "#E0DCE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 3.11051C20.4473 3.11051 20.8174 2.74041 20.8174 2.28386C20.8174 1.82732 20.4473 1.45721 19.9907 1.45721C19.5342 1.45721 19.1641 1.82732 19.1641 2.28386C19.1641 2.74041 19.5342 3.11051 19.9907 3.11051Z",
    fill: "#E0DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_6216",
    x1: 43.2418,
    y1: 3.11053,
    x2: 47.2623,
    y2: 73.6372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115334,
    stopColor: "#BCBBC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227922,
    stopColor: "#8F8D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689257,
    stopColor: "#A8A0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766146,
    stopColor: "#BFA1E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3518 9.11426) rotate(115.805) scale(19.5759 31.1391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6DE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9699 56.9789) rotate(-42.3334) scale(51.7782 51.7779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE0FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7DDF9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4014 8.3948) rotate(114.444) scale(11.5761 21.6699)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E3EF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2426 43.0064) rotate(82.9973) scale(32.9762 37.7637)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.596424,
    stopColor: "#DACEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754428,
    stopColor: "#CCB9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962131,
    stopColor: "#BCA7DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5109 21.3154) rotate(142.239) scale(59.7737 57.0512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.476664,
    stopColor: "#DACEF3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693657,
    stopColor: "#E9E2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816307,
    stopColor: "#EBE8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962131,
    stopColor: "#EAE7F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1719 23.8331) rotate(56.149) scale(57.367 65.696)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536739,
    stopColor: "#DACEF3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754428,
    stopColor: "#B9B5CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962131,
    stopColor: "#B2AEC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1714_6216",
    x1: 89.8735,
    y1: 22.5102,
    x2: 73.9736,
    y2: 22.5102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C2CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "#CFC9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514744,
    stopColor: "#B9B1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A398B4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.7835 41.4478) rotate(18.435) scale(13.3081 6.84977)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B89B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A28EBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.2764 1.66858) rotate(47.386) scale(6.8077 26.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79896,
    stopColor: "#A29EAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.7012 4.37398) rotate(136.219) scale(3.33081 5.20787)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1DEE8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1714_6216",
    x1: 81.9226,
    y1: 3.11053,
    x2: 81.9226,
    y2: 39.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1B6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818225,
    stopColor: "#B4A9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1714_6216",
    x1: 81.4014,
    y1: 62.991,
    x2: 89.8733,
    y2: 62.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E748E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#A69BB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#CBC4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C1CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.6373 80) rotate(90) scale(7.13924 20.9969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B72A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733334,
    stopColor: "#AE9AC8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1714_6216",
    x1: 85.6373,
    y1: 42.4011,
    x2: 85.6373,
    y2: 43.0513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E80A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D80A2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1714_6216",
    x1: 0.125976,
    y1: 9.48418,
    x2: 28.182,
    y2: 15.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590491,
    stopColor: "#938DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838799,
    stopColor: "#AFA3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACA0C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.23418 1.46818) rotate(41.4237) scale(2.27169 2.77485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCAD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2502 0.917094) rotate(39.2072) scale(2.45694 3.00113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCAD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6169 0.866978) rotate(48.6914) scale(2.20098 2.68847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCAD5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0979 80) rotate(90) scale(4.03304 13.1763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F78AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9883B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1714_6216",
    x1: 7.94182,
    y1: 3.27177,
    x2: 11.1983,
    y2: 79.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.142713,
    stopColor: "#B4AAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A9C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1714_6216",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1983 80.025) rotate(90) scale(4.008 30.2103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F78AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A493BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1714_6216",
    x1: 4.4342,
    y1: 3.77281,
    x2: 9.5444,
    y2: 17.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411738,
    stopColor: "#C0B9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B9CC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1714_6216",
    x1: 12.65,
    y1: 3.77284,
    x2: 17.7602,
    y2: 17.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411738,
    stopColor: "#C0B9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0B9CC",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.8f10fd53a4603033eadf2768ca5c13cb.svg";
export { ForwardRef as ReactComponent };